module.exports = __webpack_public_path__ + "static/media/9-9.ab768275.mp3";